import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg
    width="148"
    height="148"
    viewBox="0 0 148 148"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="148" height="148" rx="4" fill="#F5F6FA" />
    <path
      d="M81.6667 64H58.3333C56.4924 64 55 65.4924 55 67.3333V90.6667C55 92.5076 56.4924 94 58.3333 94H81.6667C83.5076 94 85 92.5076 85 90.6667V67.3333C85 65.4924 83.5076 64 81.6667 64Z"
      stroke="#7876C1"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.166 75.6667C65.5467 75.6667 66.666 74.5474 66.666 73.1667C66.666 71.786 65.5467 70.6667 64.166 70.6667C62.7853 70.6667 61.666 71.786 61.666 73.1667C61.666 74.5474 62.7853 75.6667 64.166 75.6667Z"
      stroke="#7876C1"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.0007 84L76.6673 75.6667L58.334 94"
      stroke="#7876C1"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M90 51.1667V62.8334"
      stroke="#7876C1"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.166 57H95.8327"
      stroke="#7876C1"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AddImageIcon = (props) => <Icon component={svg} {...props} />;

export default AddImageIcon;
